'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
var _extends = require('@babel/runtime/helpers/extends');
var react = require('@chakra-ui/react');
var React = require('react');
function _interopDefaultLegacy(e) {
  return e && typeof e === 'object' && 'default' in e ? e : {
    'default': e
  };
}
function _interopNamespace(e) {
  if (e && e.__esModule) return e;
  var n = Object.create(null);
  if (e) {
    Object.keys(e).forEach(function (k) {
      if (k !== 'default') {
        var d = Object.getOwnPropertyDescriptor(e, k);
        Object.defineProperty(n, k, d.get ? d : {
          enumerable: true,
          get: function () {
            return e[k];
          }
        });
      }
    });
  }
  n["default"] = e;
  return Object.freeze(n);
}
var _extends__default = /*#__PURE__*/_interopDefaultLegacy(_extends);
var React__namespace = /*#__PURE__*/_interopNamespace(React);
var Svg = react.forwardRef(function (props, ref) {
  return /*#__PURE__*/React__namespace.createElement("svg", _extends__default["default"]({
    width: "1em",
    height: "1em",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props, {
    ref: ref
  }), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M15.333 11.128c0 .297-.09.572-.235.814l-4.63-4.783 4.58-3.699c.178.261.285.568.285.899v6.77ZM8 8.028l6.374-5.148a1.929 1.929 0 0 0-.874-.213h-11c-.318 0-.613.08-.873.213L8 8.028Zm1.777-.312L8.302 8.91A.48.48 0 0 1 8 9.013a.48.48 0 0 1-.302-.104L6.223 7.716l-4.69 4.844c.281.163.61.26.967.26h11c.356 0 .686-.097.967-.26l-4.69-4.844ZM.952 3.46a1.588 1.588 0 0 0-.285.899v6.77c0 .296.09.571.235.813l4.63-4.783L.952 3.46Z",
    fill: "currentColor",
    fillRule: "nonzero"
  }));
});
var Mail = react.forwardRef(function (props, ref) {
  return /*#__PURE__*/React__namespace.createElement(react.Icon, _extends__default["default"]({
    as: Svg
  }, props, {
    ref: ref
  }));
});
exports.Mail = Mail;